<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
  -->

<template>
  <registration-template>
    <h1 slot="header-title">Let's review</h1>
    <h3 slot="header-description">
      Please take a minute and review your selections below
    </h3>

    <div slot="content" class="app-confirmation-container">
      <v-alert type="error" :value="errorMessage != null" class="mb-3">
        {{ errorMessage }}
      </v-alert>

      <h1>ExclusionCheck Company Plan Details</h1>

      <line-item-card title="Team Selection" :items="basePricingItem" />
      <line-item-card
        title="Search Options"
        :items="searchOptionPricingItems"
      />

      <v-layout class="row wrap pt-2">
        <v-flex class="xs12 sm6">
          <h2 class="app-confirm-section-header">Billing Contact</h2>

          {{
            creationRequest.userInfo.firstName +
              " " +
              creationRequest.userInfo.lastName
          }}
          <br />
          {{ creationRequest.userInfo.companyName }}

          <h2 class="app-confirm-section-header mt-2">Username</h2>
          <p>{{ creationRequest.userInfo.username }}</p>
        </v-flex>

        <v-flex class="xs12 sm6">
          <h2 class="app-confirm-section-header">Payment Info</h2>
          <p>Card ending in *{{ lastFourCC }}</p>
        </v-flex>
      </v-layout>

      <registration-tos class="pt-4" />

      <div class="d-flex pt-4">
        <v-spacer class="w-100" />
        <v-btn flat class="flex-none" @click.native="updateCurrentStep(2)">
          Go Back
        </v-btn>

        <v-btn
          color="primary"
          class="flex-none"
          @click.native="createUser()"
          :loading="creatingUser"
          :disabled="creatingUser"
        >
          Sign Me Up!
        </v-btn>
      </div>
    </div>
  </registration-template>
</template>
<script>
import { mapGetters, mapMutations } from "vuex"
import RegistrationTemplate from "./Registration-Template"
import RegistrationTos from "./Registration-Tos"
import CreateUser from "@/mixins/createUser"
import LineItemCard from "@/components/LineItemCard"
import { getPricingItems } from "@/service/lineitem"

export default {
  name: "RegistrationConfirmation",

  components: {
    RegistrationTemplate,
    RegistrationTos,
    LineItemCard
  },

  mixins: [CreateUser],

  computed: {
    ...mapGetters(["creationRequest", "lastFourCC"]),
    basePricingItem() {
      return getPricingItems([this.creationRequest.plan.teamType])
    },
    searchOptionPricingItems() {
      return getPricingItems(this.creationRequest.plan.searchOptions)
    }
  },

  methods: {
    ...mapMutations(["updateCurrentStep"])
  }
}
</script>

<style lang="scss" scoped>
.app-confirmation-container {
  max-width: 46rem;
  margin: 0 auto;
  text-align: left;

  h1 {
    font-weight: 600;
    font-size: 1.25rem;
  }
}
.app-confirm-section-header {
  font-weight: bold;
  font-size: 1rem;
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Registration-Confirmation.vue